// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"9768331e","168":"ebbb5ad9","368":"4ac67daa"}[chunkId] + ".chunk.js";
};